// extracted by mini-css-extract-plugin
export default {"root":"_12Sq8","body-wrapper":"_1hvp-","bodyWrapper":"_1hvp-","big":"_1ZWBs","postfix":"_2xoMj","small":"D-m7S","multiline":"_16FsT","body-node":"_1AhHy","bodyNode":"_1AhHy"};